import type * as React from "react"
import {
  LayoutDashboard,
  Search,
  TrendingUp,
  Database,
  Users,
  Settings,
  BarChart3,
  BookOpen,
  FileText,
  Building2,
} from "lucide-react"
import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import { TeamSwitcher } from "@/components/team-switcher"
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarRail } from "@/components/ui/sidebar"
import { getUserProfile, getOrganizationsProfile } from "@/lib/api"

const navMain = [
  {
    title: "Overview",
    url: "/dashboard",
    icon: LayoutDashboard,
  },
  {
    title: "AI Search",
    url: "/dashboard/search",
    icon: Search,
  },
  {
    title: "Projects",
    url: "/dashboard/projects",
    icon: Database,
    items: [
      {
        title: "All Projects",
        url: "/dashboard/projects",
      },
      {
        title: "Watchlist",
        url: "/dashboard/watchlist",
      },
    ],
  },
  {
    title: "Gate 2 Analytics",
    url: "/dashboard/gate2",
    icon: TrendingUp,
    items: [
      {
        title: "Readiness Scores",
        url: "/dashboard/gate2/readiness",
      },
      {
        title: "Regional Analysis",
        url: "/dashboard/gate2/regional",
      },
      {
        title: "Technology Trends",
        url: "/dashboard/gate2/tech",
      },
    ],
  },
  {
    title: "Reports",
    url: "/dashboard/reports",
    icon: FileText,
  },
  {
    title: "Analytics",
    url: "/dashboard/analytics",
    icon: BarChart3,
  },
  {
    title: "Documentation",
    url: "/dashboard/docs",
    icon: BookOpen,
  },
]

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const userProfile = getUserProfile()
  const organisations = getOrganizationsProfile()

  const user = {
    name: userProfile ? `${userProfile.first_name} ${userProfile.last_name}` : "User",
    email: userProfile?.email ?? "",
    avatar: userProfile?.photo_url ?? "",
  }

  const teams = organisations?.map((org) => ({
    name: org.name,
    logo: Building2 as React.ElementType,
    plan: org.type,
  })) ?? [{ name: "Organisation", logo: Building2 as React.ElementType, plan: "" }]

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher teams={teams} />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
